var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4637 7.03985C30.4843 7.33769 30.4843 7.63553 30.4843 7.93612C30.4843 17.0951 23.5117 27.6583 10.7621 27.6583V27.6528C6.99584 27.6583 3.3078 26.5795 0.137207 24.5453C0.684854 24.6112 1.23525 24.6442 1.78701 24.6455C4.90819 24.6483 7.94015 23.601 10.3956 21.6726C7.42956 21.6163 4.82858 19.6824 3.91995 16.8591C4.95897 17.0595 6.02956 17.0183 7.04936 16.7397C3.81564 16.0863 1.48917 13.2451 1.48917 9.94553C1.48917 9.91534 1.48917 9.88652 1.48917 9.85769C2.4527 10.3944 3.53152 10.6922 4.63505 10.7251C1.58936 8.68965 0.65054 4.63789 2.48976 1.47004C6.00897 5.80044 11.2013 8.43299 16.7752 8.71161C16.2166 6.30416 16.9798 3.78142 18.7805 2.08906C21.5723 -0.53525 25.9631 -0.40074 28.5874 2.38965C30.1398 2.08357 31.6276 1.51397 32.9892 0.706907C32.4717 2.31142 31.3888 3.67436 29.9421 4.54044C31.316 4.37848 32.6584 4.01063 33.9225 3.44926C32.9919 4.84377 31.8198 6.05848 30.4637 7.03985Z",
    fill: "#1D9BF0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter_logo.229853122eb0b57cfb998ad8cc41c797.svg";
export { ForwardRef as ReactComponent };